import React from "react";
import { connect } from "react-redux";
import ReactIframeResizer from "../common/iFrameResizerComponent";
import * as d from "../../reducers/domainReducer";
import { withRouter } from 'react-router';
import { logUI } from '../../api/andyliticsApi';
import { getURLPath } from '../../helpers/Tools';
import { getFirstName, queryParams } from "../../helpers/formatting";
import Spinner from "../common/spinner";
import * as types from "../../constants/actionTypes";
import StatusBanner from '../common/StatusBanner';

const SURVEY_COMPLETED_ELIGIBLE = "surveycompleted-eligible";
const SURVEY_COMPLETED_INELIGIBLE = "surveycompleted-noteligible";

class VaccineEligibilitySurveyPreBooster extends React.Component {
    constructor(props) {
        super(props);
        this.state = { surveyCompleted: false, redirectToBswFailed: false, notEligible: false, showSpinner: false };
        this.processWindowMessage = this.processWindowMessage.bind(this);
        this.redirectToBsw = this.redirectToBsw.bind(this);
        this.tryBswRedirectAgain = this.tryBswRedirectAgain.bind(this);
        this.onSurveyLoaded = this.onSurveyLoaded.bind(this);
        this.getProxyInfoCallback = this.getProxyInfoCallback.bind(this);
        this.surveyUrl = null;
        this.isIframeInitialLoaded = false;
    }

    componentDidMount() {
        window.addEventListener("message", this.processWindowMessage);
        this.isIframeInitialLoaded = false;
        const { surveyBaseUrl } = this.props;
        let andyliticsJson = {
            surveyBaseUrl
        };
        logUI("MBHWeb.UI.Covid19VaccineEligibilitySurvey.ComponentDidMount", new Date(), getURLPath(), andyliticsJson);
    }

    //Callback to validate auth feature and route to vaccine search.
    getProxyInfoCallback(proxyList, status) {
        const { currentUser, history, isCovidVaxScheduleEligible, enableCovidScheduleAuthFeature } = this.props;
        if (status) {
            this.setState({ showSpinner: false, surveyCompleted: true }, () => {
                if ((enableCovidScheduleAuthFeature === false || (enableCovidScheduleAuthFeature && isCovidVaxScheduleEligible))) {
                    let vaccineLocUrl = '/findcare/vaccine';
                    let findcareSearchParms = "?" + queryParams({
                        xid: currentUser.externalId
                    });
                    vaccineLocUrl = vaccineLocUrl + findcareSearchParms;
                    history.push(vaccineLocUrl);
                    logUI("MBHWeb.UI.Covid19VaccineEligibilitySurvey.SCHDCOVIDVAX.Enabled", new Date(), getURLPath(), { "currentUser": currentUser });
                } else {
                    this.setState({ notEligible: true });
                    logUI("MBHWeb.UI.Covid19VaccineEligibilitySurvey.SCHDCOVIDVAX.NotEnabled", new Date(), getURLPath(), { "currentUser": currentUser ? currentUser : "" });
                }
            });
        } else {
            //failure
            this.setState({ showSpinner: false, surveyCompleted: true, notEligible: true });
            logUI("MBHWeb.UI.Covid19VaccineEligibilitySurvey.SCHDCOVIDVAX.ProxyInfoFailure", new Date(), getURLPath(), { "currentUser": currentUser ? currentUser : "" });
        }
    }

    onSurveyLoaded(event) {
        if (!this.isIframeInitialLoaded) {
            logUI("MBHWeb.UI.Covid19VaccineEligibilitySurvey.Loaded", new Date(), getURLPath(), { surveyUrl: this.surveyUrl });
            this.isIframeInitialLoaded = true;
        }
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.processWindowMessage);
    }

    processWindowMessage(messageEvent) {
        const { getProxyInformation, currentUser } = this.props;
        if (messageEvent) {
            switch (messageEvent.data) {
                case SURVEY_COMPLETED_ELIGIBLE:
                    this.setState({ showSpinner: true }, () => {
                        getProxyInformation(this.getProxyInfoCallback);
                    });
                    logUI("MBHWeb.UI.Covid19VaccineEligibilitySurvey.Completed.Eligible", new Date(), getURLPath(), { "currentUser": currentUser ? currentUser : "" });
                    break;
                case SURVEY_COMPLETED_INELIGIBLE:
                    logUI("MBHWeb.UI.Covid19VaccineEligibilitySurvey.Completed.Ineligible", new Date(), getURLPath(), { "currentUser": currentUser ? currentUser : "" });
                    this.setState({ surveyCompleted: true }, () => { this.redirectToBsw() });
                    break;
                default:
                    if (typeof messageEvent.data === 'string' && messageEvent.data.indexOf('[iFrameSizer]') === -1) {
                        logUI("MBHWeb.UI.Covid19VaccineEligibilitySurvey." + (messageEvent.data ? messageEvent.data : "unknown"), new Date(), getURLPath());
                    }
            }
        }
    }

    redirectToBsw() {
        var newWin = window.open(this.props.bswCovid19VaccinePage, '_blank');
        if (!newWin || newWin.closed || typeof newWin.closed === 'undefined') {
            this.setState({ redirectToBswFailed: true });
        } else {
            //debugger;
            this.props.history.push('/');
        }
    }

    tryBswRedirectAgain() {
        logUI("MBHWeb.UI.Covid19VaccineEligibilitySurvey.Ineligible.TryRedirectAgain.Clicked", new Date(), getURLPath());
        //debugger;
        this.props.history.push('/')
    }

    render() {
        const { reloadKey, surveyBaseUrl, surveyIdForCovidVaccine, isProxyUser, currentUser, age, bswCovid19VaccinePage, userName, proxyListFailure, proxyListLoaded, headerProxyUser } = this.props;
        const userId = currentUser && currentUser.epi ? currentUser.epi : "";
        const { redirectToBswFailed, showSpinner, notEligible } = this.state;
        const iframeResizerOptions = { checkOrigin: false, scrolling: true, heightCalculationMethod: 'bodyScroll', warningTimeout: 10000 };
        const iframeResizerStyle = { width: '100%' };
        const formID = "VaccineEligibilitySurvey";
        const userAge = currentUser && currentUser.ageYears ? currentUser.ageYears : "";
        const firstName = currentUser && currentUser.displayName ? getFirstName(currentUser.displayName) : "";
        this.surveyUrl = surveyBaseUrl + "Covid/VaccinationSurvey/" + surveyIdForCovidVaccine + "?UserId=" + userId
            + "&ExternalEventId=covid2021&Age=" + userAge + "&Platform=WEB" + (isProxyUser ? "&firstname=" + firstName + "&proxyUserName=" + encodeURIComponent(userName) : "");

        return ((!this.state.surveyCompleted && !showSpinner)
            ? <React.Fragment>
                {this.surveyUrl &&
                    <div className="mychartDataTile vaccine-eligibility-survey">
                        <React.Fragment >
                            <ReactIframeResizer ref="thisFrame" key={reloadKey} id={formID} title="Vaccine Eligibility Survey" onIframeLoaded={this.onSurveyLoaded} iframeResizerOptions={iframeResizerOptions} src={this.surveyUrl} style={iframeResizerStyle} />
                        </React.Fragment >
                    </div>
                }
            </React.Fragment>
            : <div className="container-fluid body-content check-vaccine-eligibility">
                {((!proxyListFailure && !proxyListLoaded) || !currentUser || !headerProxyUser || showSpinner) && <Spinner />}
                {notEligible && <div className="row"><div className="col-12">
                    <StatusBanner bannerMsg="We're sorry, we're unable to proceed" failedStatus bannerAlignment="left">
                        <span>
                            An error occurred while processing this request. Please try again later.
                        </span>
                    </StatusBanner>
                </div></div>}
                {redirectToBswFailed &&
                    <div className="row popup-blocked">
                        <div className="col-12 maxWidth-content">
                            <h1 className="page-heading">COVID-19 Vaccine Eligibility</h1>
                            <div className="popup-blocked__msg">
                                <span className="icon-info-filled" />
                                <div className="popup-blocked__msg--text">
                                    <p>We attempted to launch the eligibility information in a new window, but a popup blocker is preventing it.</p>
                                    <p>Please allow popups for this site and try again.</p>
                                </div>
                            </div>
                            <a className="btn btn-primary" href={bswCovid19VaccinePage} target="_blank" onClick={this.tryBswRedirectAgain}>TRY AGAIN</a>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { surveyUrl, surveyIdForCovidVaccine, bswCovid19VaccinePage } = state.session.serverData;
    return {
        reloadKey: state.session.reloadKey,
        userName: state.domain.un,
        surveyBaseUrl: surveyUrl,
        surveyIdForCovidVaccine: surveyIdForCovidVaccine,
        bswCovid19VaccinePage: bswCovid19VaccinePage ? bswCovid19VaccinePage : 'https://www.bswhealth.com/covid-vaccine',
        isProxyUser: state.domain.ip,
        age: state.domain.age,
        currentUser: d.hydrateProxyUser(state.domain.cu),
        proxyListFailure: state.memberships.proxyListFailure,
        proxyListLoaded: state.memberships.proxyListLoaded,
        proxyListLoading: state.memberships.proxyListLoading,
        headerProxyUser: state.memberships.currentUser,
        isCovidVaxScheduleEligible: state.memberships.hasAuthorizedFeatureSchedCovidVax,
        enableCovidScheduleAuthFeature: state.session.serverData && state.session.serverData.enableCovidScheduleAuthFeature ? state.session.serverData.enableCovidScheduleAuthFeature : false
    };
};
const mapDispatchToProps = (dispatch) => ({
    getProxyInformation: (callback) => dispatch({ type: types.REFRESH_PROXY_LIST, callback: callback })
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VaccineEligibilitySurveyPreBooster));